<template>
  <NavigationHeader title="Recherchez dans l’ensemble du site" />
</template>

<script>
export default {
  name: 'SearchHeader'
}
</script>
